import type { FuseThemeType } from "@fuse/core/FuseSettings/FuseSettings";
import { createTheme, type Theme, type ThemeOptions } from "@mui/material/styles";
import _ from "lodash";
import { defaultThemeOptions, extendThemeWithMixins, mustHaveThemeOptions } from "@fuse/default-settings";
import useFuseSettings from "./useFuseSettings";

type Direction = "ltr" | "rtl";

const generateMuiTheme = (theme: FuseThemeType, direction: Direction, prefix?: string): Theme => {
	const mergedTheme = _.merge({}, defaultThemeOptions, theme, mustHaveThemeOptions, {
		cssVariables: { cssVarPrefix: prefix },
	}) as ThemeOptions;
	const themeOptions = {
		...mergedTheme,
		mixins: extendThemeWithMixins(mergedTheme),
		direction,
	} as ThemeOptions;
	return createTheme(themeOptions);
};

export const useMainTheme = (): Theme => {
	const { data: current } = useFuseSettings();
	return generateMuiTheme(current.theme.main, current.direction);
};

export const useNavbarTheme = (): Theme => {
	const { data: current } = useFuseSettings();
	return generateMuiTheme(current.theme.navbar, current.direction, "navbar");
};

export const useToolbarTheme = (): Theme => {
	const { data: current } = useFuseSettings();
	return generateMuiTheme(current.theme.toolbar, current.direction, "toolbar");
};

export const useFooterTheme = (): Theme => {
	const { data: current } = useFuseSettings();
	return generateMuiTheme(current.theme.footer, current.direction, "footer");
};
